import React from "react";

import { IconCheck, IconCheckEmpty } from "../../../../../../Components/Icons";
import { Plus } from "../../../Svg";

import {
  AssetContainer,
  AssetSelector,
  AssetWrapper,
  ImageSelectionWrapper
} from "./AssetPreview.styled";
import InputPreview from "../../../TemplatePost/TemplatePost__TemplateEditor/ImageVideoInputPreview/InputPreview/InputPreview";

const AssetPreview = ({ isLogo, assetList, assetInUse, emitNewAsset, emitUpdateInputProps }) => {
  return (
    <AssetWrapper>
      {assetList.map((image) => {
        const imageSelected = image === assetInUse;

        return (
          <AssetSelector key={image} onClick={() => emitUpdateInputProps(image)}>
            {isLogo ? (
              <AssetContainer isLogo={true} src={image} alt="" />
            ) : (
              <InputPreview asset={image} />
            )}
            <ImageSelectionWrapper>
              {imageSelected ? <IconCheck /> : <IconCheckEmpty />}
            </ImageSelectionWrapper>
          </AssetSelector>
        );
      })}

      <AssetSelector onClick={() => emitNewAsset()}>
        <Plus />
      </AssetSelector>
    </AssetWrapper>
  );
};

export default AssetPreview;
